{
  "messages": {
    "el": {
      "subtitle": {
        "authLogin": "Αποκτήστε πρόσβαση στα αγαπημένα σας, στις αποθηκευμένες αναζητήσεις και στις εξατομικευμένες ειδοποιήσεις",
        "authOtp": "Ελέγξτε το email σας, σας έχουμε στείλει έναν κωδικό μίας χρήσης",
        "authOtpExpired": "Ο κωδικός μίας χρήσης έχει λήξει",
        "authRegister": "Συμπληρώστε τα προσωπικά σας στοιχεία παρακάτω για να δημιουργήσετε το νέο σας προφίλ και να ξεκινήσετε μαζί μας!",
        "interestError": "Υπήρξε ένα πρόβλημα. Παρακαλώ ανανεώστε τη σελίδα και δοκιμάστε ξανά",
        "interestSuccess": "Θα επικοινωνήσουμε σύντομα μαζί σας",
        "listPropertyAdditional": "Δίνοντάς μας περισσότερες λεπτομέρειες για το ακίνητό σου, μας βοηθάς να ολοκληρώσουμε γρηγορότερα τη διαδικασία υποβολής.",
        "listPropertyBasic": "Δώσε μας μερικές πληροφορίες για το ακίνητό σου",
        "listPropertyPersonalDetails": "Δώστε μας πληροφορίες για να επικοινωνήσουμε μαζί σας.",
        "listPropertySuccess": "Ένας εκπρόσωπός μας θα επικοινωνήσει μαζί σου σύντομα για να ολοκληρώσετε την καταχώρηση.",
        "listPropertySuccessNoLocation": "Ένας εκπρόσωπός μας θα επικοινωνήσει μαζί σου μόλις η περιοχή σου είναι διαθέσιμη στην πλατφόρμα μας.",
        "mortgage": "H Prosperty σε συνεργασία με τη FinTHESIS σου δίνει τη δυνατότητα να κάνεις online αίτηση, σε μόλις 5 λεπτά και χωρίς επίσκεψη σε τράπεζα!",
        "mortgageError": "Υπήρξε ένα πρόβλημα. Παρακαλώ ανανεώστε τη σελίδα και δοκιμάστε ξανά",
        "mortgageSuccess": "Ένας {company} agent θα επικοινωνήσει σύντομα μαζί σου.",
        "offer": "Συμπλήρωσε το ποσό που θέλεις να καταβάλεις και δες αν θα αποδεχτεί την προσφορά ο ιδιοκτήτης",
        "offerAdditional": "Συμπλήρωσε τις απαραίτητες πληροφορίες για να προχωρήσεις με την προσφορά σου",
        "offerError": "Υπήρξε ένα πρόβλημα. Παρακαλώ ανανεώστε τη σελίδα και δοκιμάστε ξανά",
        "offerSuccess": "Ένας εκπρόσωπός μας θα επικοινωνήσει μαζί σου το συντομότερο δυνατό.",
        "openDay": "Σε ευχαριστούμε για την εγγραφή σου στην Open Day. Θα επικοινωνήσουμε μαζί σου σύντομα για την επιβεβαίωση της συμμετοχής σου.",
        "openDayError": "Υπήρξε ένα πρόβλημα. Παρακαλώ ανανεώστε τη σελίδα και δοκιμάστε ξανά",
        "tourError": "Υπήρξε ένα πρόβλημα. Παρακαλώ ανανεώστε τη σελίδα και δοκιμάστε ξανά",
        "unlockDocumentsError": "Υπήρξε ένα πρόβλημα. Παρακαλώ ανανεώστε τη σελίδα και δοκιμάστε ξανά"
      },
      "title": {
        "authLogin": "Σύνδεση ή Δημιουργία λογαριασμού",
        "authOtp": "Επαλήθευση κωδικού μίας χρήσης",
        "authRegister": "Δημιουργία Λογαριασμού",
        "interestError": "Σφάλμα",
        "interestSuccess": "Το αίτημα σας έχει σταλεί!",
        "listPropertyAdditional": "Χαρακτηριστικά ακινήτου",
        "listPropertyBasic": "Προώθησε το ακίνητό σου",
        "listPropertyPersonalDetails": "Προσωπικά στοιχεία",
        "listPropertySuccess": "Το ακίνητό σου καταχωρήθηκε επιτυχώς",
        "listPropertySuccessNoLocation": "Σ’ ευχαριστούμε για το ενδιαφέρον σου να προωθήσεις το ακίνητό σου μέσω της {client}",
        "mortgage": "Προέγκριση δανείου εύκολα και γρήγορα με το e-stegastiko!",
        "mortgageError": "Σφάλμα",
        "mortgageSuccess": "Σε ευχαριστούμε για το ενδιαφέρον σου για δάνειο!",
        "offer": "Πρότεινε μία τιμή",
        "offerAdditional": "Eπιπλέον πληροφορίες",
        "offerError": "Σφάλμα",
        "offerSuccess": "Ένας εκπρόσωπός μας θα επικοινωνήσει μαζί σου το συντομότερο δυνατό",
        "offerTerms": "Όροι και Προϋποθέσεις",
        "openDay": "Η εγγραφή ολοκληρώθηκε!",
        "openDayError": "Σφάλμα",
        "tourError": "Σφάλμα",
        "tourSuccess": "Το αίτημα επίσκεψής σας έχει σταλεί! Θα λάβετε σύντομα ένα email επιβεβαίωσης.",
        "unlockDocumentsError": "Σφάλμα"
      }
    },
    "en": {
      "subtitle": {
        "authLogin": "Access favorites, saved searches, and personalized alerts",
        "authOtp": "Check your email, we’ve sent a one-time passcode",
        "authOtpExpired": "The passcode has expired",
        "authRegister": "Fill in your personal information below to set up your new profile and start your journey with us!",
        "interestError": "There was an issue.Please refresh the page and try again",
        "interestSuccess": "Our agent will contact you soon",
        "listPropertyAdditional": "Giving us more details about your property will help us finalize your submission faster.",
        "listPropertyBasic": "Give us a few details about your property",
        "listPropertyPersonalDetails": "Giving us your personal details, so we can contact you.",
        "listPropertySuccess": "An expert will contact with you to finalize your submission.",
        "listPropertySuccessNoLocation": "An expert will contact with you as soon as your area is available in our platform.",
        "mortgage": "Prosperty, in partnership with FinTHESIS, lets you apply online in just 5 minutes—no bank visit needed!",
        "mortgageError": "There was an issue.Please refresh the page and try again",
        "mortgageSuccess": "Your personal agent will contact you soon.",
        "offer": "Suggest the price you wish to buy this property for and the owner may accept it",
        "offerAdditional": "Fill the required information below to proceed with your offer",
        "offerError": "There was an issue.Please refresh the page and try again",
        "offerSuccess": "An expert will contact with you as soon as possible.",
        "openDay": "Thank you for registering to the Open Day event. We will contact you soon for the final confirmation.",
        "openDayError": "There was an issue.Please refresh the page and try again",
        "tourError": "There was an issue.Please refresh the page and try again",
        "unlockDocumentsError": "There was an issue.Please refresh the page and try again"
      },
      "title": {
        "authLogin": "Sign In or Create an Account",
        "authOtp": "Verify One-Time Passcode",
        "authRegister": "Create an account",
        "interestError": "Error",
        "interestSuccess": "Your request has been sent!",
        "listPropertyAdditional": "Property details",
        "listPropertyBasic": "List your property",
        "listPropertyPersonalDetails": "Personal details",
        "listPropertySuccess": "Your property has been submitted successfully!",
        "listPropertySuccessNoLocation": "Thank you for your interest in listing your property with us",
        "mortgage": "Fast & hassle-free mortgage pre-approval with e-stegastiko",
        "mortgageError": "Error",
        "mortgageSuccess": "Thank you for your interest on the mortgage!",
        "offer": "Tell us your price",
        "offerAdditional": "Additional information",
        "offerError": "Error",
        "offerSuccess": "Thank you for your interest",
        "offerTerms": "Terms & Conditions",
        "openDay": "Registration completed!",
        "openDayError": "Error",
        "tourError": "Error",
        "tourSuccess": "Your visit request has been sent! You will receive a confirmation email shortly.",
        "unlockDocumentsError": "Error"
      }
    }
  }
}
